import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const ENERGY_DOMAIN_INTRO = {
  title: "Energy & Utilities",
  content: "Document AI + RPA and workflow automation across Utilities. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "Energy & Utilities automation use cases — document AI + RPA and workflow automation across Utilities. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "SCADA, GIS, CRM, ERP, Field Service Management, Email, Power BI";

const RAW = [
  {
    id: "vendor-invoice-and-work-order-matching",
    subIndustry: "Utilities",
    department: "Finance",
    businessProcess: "Vendor invoice and work order matching",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Vendor invoice and work order matching",
    title: "Vendor Invoice And Work Order Matching Automation for Energy & Utilities",
    seoKeywords: "energy & utilities, vendor invoice and work order matching, AI automation, RPA, agentic AI, document AI",
    challenge: "Invoices from contractors are manually matched with POs, work orders and site confirmations.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "CFO, Procurement Head",
    systems: "ERP, CMMS, Email, Vendor Portal",
    agentsRequired: "Document Extraction Agent, Vendor Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and vendor invoice and work order matching rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready vendor invoice and work order matching record",
    keyBenefits: "Faster Closure, Fewer Reconciliation Errors, Reduced Manual Effort And Better Finance Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
];
export const ENERGY_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Utilities"];
export const ENERGY_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => ENERGY_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'energy-utilities-domain',
  domainIntro: ENERGY_DOMAIN_INTRO,
  useCases: ENERGY_USE_CASES,
});
export const ENERGY_USE_CASES_SEO = seo.useCasesSeo;
export const ENERGY_DOMAIN_FAQS = seo.domainFaqs;
export const ENERGY_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const ENERGY_FAQ_JSONLD = seo.faqJsonLd;
export const ENERGY_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const ENERGY_WEBPAGE_JSONLD = seo.webPageJsonLd;

